import { useContext, useEffect } from "react";
import { SsrRequestContext } from "@/lib/ssr-bootstrap";
import { applyPageMeta, type PageMeta } from "@/lib/seo";

/** Same metadata inputs for request-owned SSR collection and the browser effect. */
export function usePublicPageMeta(meta: PageMeta | null) {
  const request = useContext(SsrRequestContext);
  const canonical = request?.canonical || meta?.canonical;
  if (request && meta) request.pageMeta = { ...meta, canonical };
  useEffect(() => { if (meta) applyPageMeta({ ...meta, canonical }); }, [meta, canonical]);
}
